import TabOptions from '../options';

export class Model {}
export class Tab {
  id = 'Five';
  title = 'V';
  valid = true;
  model = new Model();
  options = new TabOptions(new Model());
  build = () => {
    return {
      tab: this.id,
    };
  };
}
export default new Tab();
